import React from "react";
import { withTranslation } from "react-i18next";

function WorkerStatusBadge({ status, t }) {
  const isPresent = status === "clocked_in" || status === "present";

  return (
    <span
      className={isPresent ? "badge badge-success" : "badge badge-secondary"}
      style={{
        padding: "5px 10px",
        borderRadius: "12px",
        fontSize: "12px",
        fontWeight: "bold",
      }}
    >
      {isPresent ? t("Presente") : t("Ausente")}
    </span>
  );
}

export default withTranslation()(WorkerStatusBadge);
